
















































































































































































































































import Vue from 'vue';
import { Component, Prop, Provide } from 'vue-property-decorator';
import { VMoney } from 'v-money';
import IconInfoDescription from '@/shared/icons/icon-info-description.component.vue';
import KeyValueParameter from '@/shared/parameters/key-value-parameter.component.vue';
import RoleComponent from '@/shared/parameters/role-component.vue';
import Rules from '@/shared/rules/rules';
import Rule from '@/domain/rule/entity/rule.entity';
import RuleGroup from '@/domain/scripts/entity/rule-group.entity';
import BooleanType from '../../contract/manage-calculation/boolean-type.json';

@Component({
  components: {
    IconInfoDescription,
    KeyValueParameter,
    RoleComponent,
  },
  directives: {
    money: VMoney,
  },
})
export default class ManageRuleParameter extends Vue {
  @Prop({
    required: true,
    default: [],
  }) restrictRules!: Rule[];

  @Prop() editMode!: boolean;

  @Prop() isAdministrator!: boolean;

  @Prop() previewModeValue!: boolean;

  @Prop({
    required: true,
    default: [],
  }) ruleGroup!: RuleGroup;

  validationsRules: Rules = new Rules();

  booleanType = BooleanType;

  stringListInput = '';

  checkDisabledField(ruleId: string): boolean {
    return this.checkReadOnlyField(ruleId);
  }

  checkReadOnlyField(ruleId: string): boolean {
    return this.previewModeValue;
  }

  getRulesByType(type: string) {
    if (type === 'MONEY2' || type === 'RANGE2' || type === 'RANGE_PERCENT2') {
      return this.validationsRules.money2EqualOrBiggerThanZero
    }
    return this.validationsRules.moneyEqualOrBiggerThanZero;
  }

  getTypeInput(type: string) {
    if (type === 'MONEY2' || type === 'RANGE2') {
      return this.money2
    }

    if (type === 'MONEY' || type === 'RANGE') {
      return this.money
    }

    if (type === 'RANGE_PERCENT2') {
      return this.percent2
    }

    return this.percent
  }

  get money() {
    return {
      decimal: ',',
      thousands: '.',
      precision: 2,
      prefix: '$ ',
      masked: false,
      max: 9999.99,
      min: 0.01,
    };
  }

  get money2() {
    return {
      decimal: ',',
      thousands: '.',
      precision: 4,
      prefix: '$ ',
      masked: false,
      max: 9999.9999,
      min: 0.0001,
    };
  }

  percent: object = {
    decimal: ',',
    thousands: '.',
    precision: 2,
    prefix: '% ',
    masked: false,
    max: 9999.99,
    min: 0.01,
  }

  percent2: object = {
    decimal: ',',
    thousands: '.',
    precision: 4,
    prefix: '% ',
    masked: false,
    max: 9999.9999,
    min: 0.0001,
  }
}
